import { useRecoilState } from "recoil";
import BaseDialog from "./BaseDialog";
import { trialBlockModalState } from "@/recoil/atom";

/**
 * 체험용 계정 마이페이지 접근 제한 모달.
 *
 * 전역으로 한 번만 마운트되며(_app.tsx), trialBlockModalState 가 true 가 되면 노출된다.
 * 학습통계·AI 진단·내가 푼 문제·마이페이지 진입 시 useTrialBlock() 으로 열린다.
 */
export default function TrialBlockModal() {
  // name 은 모달에 표시할 기능 이름이자 동시에 열림 상태 값이다.
  // null 이면 닫힘, 문자열이면 그 이름으로 열림이다. 별도의 isOpen 플래그를 두지 않는다.
  const [name, setName] = useRecoilState(trialBlockModalState);
  const close = () => setName(null);

  return (
    <BaseDialog
      isOpen={name !== null}
      onClose={close}
      title={`${name} 접근 제한`}
    >
      <p className="text-16 text-strong font-normal leading-relaxed">
        체험용 계정은 {name} 접근이 제한돼요.
      </p>
      <button
        type="button"
        onClick={close}
        data-autofocus
        className="mt-6 w-full rounded-[12px] bg-primary py-3 text-16 font-bold text-white hover:bg-primary-hover"
      >
        확인
      </button>
    </BaseDialog>
  );
}
